import styled from 'styled-components'
// views
import { BottomPaper as BottomPaperOrigin } from 'themes/views/settings'

export const Form = styled('form')`
  display: flex;
  position: relative;
  flex-direction: column;
  height: calc(100% - 121px);
  overflow: auto;

  > div {
    padding: 16px 24px 0 16px;
  }
`

export const Wrapper = styled('div')`
  margin-bottom: 16px;

  > div {
    margin-bottom: 16px;
  }
`

// @ts-ignore
export const BottomPaper = styled(BottomPaperOrigin)`
  && {
    margin: 0;
    position: fixed;
    bottom: 0;
    right: 0;
    width: 800px;
    z-index: 100;

    > div:first-child {
      margin-right: 16px;
    }
  }
`
